"use client";

import type { UseOfficeSearchParams } from "./types";

import { useQuery } from "@tanstack/react-query";
import { fetchOfficeSearch } from "./fetch-office-search";

/**
 * React-query fetch wrapper for general office geo search.
 */
function useOfficeSearch({ config, ...params }: UseOfficeSearchParams) {
  return useQuery({
    // Disable query if location is empty or enabled is explicitly false
    enabled: params.enabled !== false && Boolean(params.location?.trim()),
    queryFn: () => fetchOfficeSearch(params, config),
    queryKey: ["officeSearch", params, config?.apiEndpoint],
  });
}

export { useOfficeSearch };
